import React from 'react';

import TopPerformersTable from '../../components/Table/TopPerformersTable';

const TopPerformers = () => (
  <div className="content">
    <TopPerformersTable />
  </div>
);

export default TopPerformers;


// WEBPACK FOOTER //
// ./src/pages/TopPerformers/index.js